import {
  CargoType,
  Odometer,
  DriverType,
  AppDataApiFactory,
  FuelType,
  TrailerType,
  Suspension,
  Ownership,
} from "./../service-proxies";
import { AxiosInstance } from "axios";
import { IAppData } from "../../redux/reducers/appDataReducer";

export const requestAppData = async (
  axiosInstance: AxiosInstance,
  baseURL: string
): Promise<IAppData> => {
  const appData = await AppDataApiFactory(
    undefined,
    baseURL,
    axiosInstance
  ).apiAppAppdataAppdataGet();

  return {
    countries: appData.data.countries ?? [],
    cargoTypes: appData.data.cargoTypes?.map(
      (cargoType) => cargoType as CargoType
    ),
    odometerTypes: appData.data.odometerTypes?.map(
      (odometerType) => odometerType as Odometer
    ),
    knownDocumentTypes: appData.data.knownDocumentTypes,
    roles: appData.data.roles,
    driverTypes: appData.data.driverTypes?.map(
      (driverType) => driverType as DriverType
    ),
    dutyStatuses: appData.data.dutyStatuses,
    companies: appData.data.companies ?? [],
    groups: appData.data.fleetManagerGroups,
    fuelTypes: appData.data.fuelTypes?.map((fuelType) => fuelType as FuelType),
    timeZones: appData.data.terminalTimeZones?.map((tz) => ({
      id: tz.timeZoneId,
      name: tz.timeZoneName,
    })),
    trailerTypes: appData.data.trailerTypes?.map(
      (trailerType) => trailerType as TrailerType
    ),
    violationTypes: appData.data.violationTypes,
    trailerOwnershipTypes: appData.data.trailerOwnershipTypes?.map(
      (ownership) => ownership as Ownership
    ),
    trailerSuspensionTypes: appData.data.trailerSuspensionTypes?.map(
      (suspension) => suspension as Suspension
    ),
    actionPermissions: appData.data.actionPermissionDefinitions,
    fieldPermissions: appData.data.fieldPermissions,
    eldDevices: appData.data.eldDevices,
    databaseServers: appData.data.databaseServers,
    tenants: appData.data.tenants,
    multiTenancySide: appData.data.multiTenancySide,
    tenant: appData.data.tenant,
    apiUrl: appData.data.apiUrl,
    webAppUrl: appData.data.webAppUrl,
    hosExceptions: appData.data.hosExceptions,
    timeZoneInfo: appData.data.currentCompanyTimeZone,
    sensorAttributes: appData.data.sensorAttributes ?? [],
    eventTypeCodes: appData.data.eventTypeCodes ?? {},
  };
};
